export enum EOpenPoseInteractionMode {
  ROTATE = 'rotate',
  DRAG_NODE = 'drag_node',
  DRAG_NODE_FIXED_LENGTH = 'drag_node_fixed_length',
}
